import styles from './Spinner.module.scss'

const Spinner = () => <div className={styles.Loader}></div>;

export default Spinner;